const POLL_INTERVAL = 50;
const MAX_ATTEMPTS = 30;
const HEADER_OFFSET = 112;

export function scrollToElement(id: string): void {
  if (typeof document === 'undefined') return;

  const el = document.getElementById(id);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
    return;
  }

  let attempts = 0;
  const poll = () => {
    const found = document.getElementById(id);
    if (found) {
      const top =
        found.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
      window.scrollTo({ top, behavior: 'smooth' });
      return;
    }
    attempts++;
    if (attempts < MAX_ATTEMPTS) {
      setTimeout(poll, POLL_INTERVAL);
    }
  };
  poll();
}
